export default "__VITE_ASSET__ccd46ade__"